import React from "react";
import SiTextField from "../../core/si-textfield";
import { Grid } from "@mui/material";

const StaticForm = ({ config }) => {
  return (
    <div>
      {config.map((field, idx) => {
        return (
          <Grid
            container
            sx={{ display: "flex", alignItems: "center", mb: 1.5 }}
          >
            <Grid item md={6} xs={12} sx={{ mb: { md: 0, xs: 1 } }}>
              {field.label}
            </Grid>
            <Grid item md={6} xs={12}>
              <SiTextField
                value={field.value}
                disabled={true}
                title={field.value}
              />
            </Grid>
          </Grid>
        );
      })}
    </div>
  );
};

export default StaticForm;
